<template>
  <button
    v-if="timestamp && clickable"
    type="button"
    class="comment-content__timestamp is-clickable"
    :class="[className, { 'is-history': history, 'is-deleted': deleted }]"
    @click.stop="onTimestampClick"
  >
    <icon
      data="@icon/play-timestamp.svg"
      color="currentColor"
      width="var(--icon-16)"
      height="var(--icon-16)"
    />
    <BaseSubHeading
      size="medium"
      weight="500"
      className="comment-content__timestamp-value"
      color="monochrome-06"
    >
      {{ timestamp }}
    </BaseSubHeading>
    <BaseSubHeading
      v-if="history && label"
      size="medium"
      weight="400"
      className="comment-content__timestamp-label"
      color="monochrome-06"
    >
      {{ label }}
    </BaseSubHeading>
  </button>
  <div
    v-else-if="timestamp"
    class="comment-content__timestamp"
    :class="[className, { 'is-history': history, 'is-deleted': deleted }]"
  >
    <icon
      data="@icon/play-timestamp.svg"
      color="currentColor"
      width="var(--icon-16)"
      height="var(--icon-16)"
    />
    <BaseSubHeading
      size="medium"
      weight="500"
      className="comment-content__timestamp-value"
      color="monochrome-06"
    >
      {{ timestamp }}
    </BaseSubHeading>
    <BaseSubHeading
      v-if="history && label"
      size="medium"
      weight="400"
      className="comment-content__timestamp-label"
      color="monochrome-06"
    >
      {{ label }}
    </BaseSubHeading>
  </div>
</template>

<script setup lang="ts">
import { getTimestampSeconds } from "@/utils/timestampUtil"

interface Props {
  timestamp: string
  clickable?: boolean
  className?: string
  history?: boolean
  label?: string
  deleted?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  clickable: false,
  className: "",
  history: false,
  label: "",
  deleted: false
})

const emit = defineEmits<{
  (event: "timestampClick", seconds: number): void
}>()

function onTimestampClick() {
  emit("timestampClick", getTimestampSeconds(props.timestamp) ?? 0)
}
</script>
